import React, { useEffect, useRef, useState } from 'react';
import Icon from '../common/Icon';
import { shouldAnimate } from '../../utils/motion';

/**
 * Four-step process whose connecting line fills as the visitor scrolls.
 */
export default function ProcessSteps({ steps }) {
  const ref = useRef(null);
  const [progress, setProgress] = useState(1);

  useEffect(() => {
    if (!shouldAnimate()) return undefined;
    let frame = 0;

    const update = () => {
      frame = 0;
      const element = ref.current;
      if (!element) return;
      const rect = element.getBoundingClientRect();
      const value = (window.innerHeight * 0.75 - rect.top) / (rect.height * 0.7);
      setProgress(Math.max(0, Math.min(1, value)));
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div className="home-steps-wrap" ref={ref} style={{ '--steps-progress': progress }}>
      <div className="home-steps-track" aria-hidden="true"><span /></div>
      <ol className="home-steps" data-reveal>
        {steps.map((step, index) => {
          const lit = progress >= index / (steps.length - 1) - 0.02;
          return (
            <li key={step.title} className={`home-step ${lit ? 'is-lit' : ''}`}>
              <span className="home-step-number" aria-hidden="true">{index + 1}</span>
              <span className="home-icon-tile home-icon-tile--sm"><Icon name={step.icon} draw /></span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <small>{step.note}</small>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
